import NumberFormat from 'react-number-format'
import React from 'react'

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat | null) => void
  onChange: (event: { target: { value: string } }) => void
  value?: string
}

export const MoneyFormattedInput: React.FC<NumberFormatCustomProps> = ({ inputRef, onChange, ...other }) => (
  <NumberFormat
    {...other}
    getInputRef={inputRef}
    onValueChange={values => {
      onChange({
        target: {
          value: values.value,
        },
      })
    }}
    thousandSeparator
    isNumericString
    prefix="$"
    decimalScale={2}
    fixedDecimalScale
  />
)

export const PercentFormattedInput: React.FC<NumberFormatCustomProps> = ({ inputRef, onChange, value, ...other }) => (
  <NumberFormat
    {...other}
    getInputRef={inputRef}
    value={value && parseFloat(value) * 100}
    decimalScale={2}
    onValueChange={values => {
      onChange({
        target: {
          value: values.value && (Number(values.value) / 100).toFixed(4),
        },
      })
    }}
    isNumericString
    // allowLeadingZeros
    // decimalSeparator
    suffix="%"
  />
)
